import { mergeSx } from '../../../util/mui/sx';
import { Typography, type TypographyProps } from '../../typography/Typography';

export interface ListItemDescriptionProps extends Omit<
  TypographyProps<'div'>,
  'component' | 'overflow' | 'textOverflow'
> {}

export const ListItemDescription = ({
  children,
  lineClamp = 2,
  ...props
}: ListItemDescriptionProps) => (
  <Typography
    color='text.secondary'
    fontSize='12px'
    lineHeight='18px'
    {...props}
    component='div'
    lineClamp={lineClamp}
    overflow='hidden'
    sx={mergeSx(props.sx, { wordBreak: 'break-word' })}
    textOverflow='ellipsis'
    whiteSpace='pre-wrap'
  >
    {children}
  </Typography>
);
